/**
 * Last UI/UX pass (Opus F11): the storage account a Create dialog acts on — "jamsqlazsttest (Contoso Storage (key))" —
 * so with several storage connections open the dialog says which account, as the change dialogs name their target (N10).
 */
import type { Connection } from '../../../../types/electron';
import { resolveStorageEndpoints } from '../../../../core/engines/azureStorageEndpointResolution';
import { useConnectionStore } from '../../../connections/store/connectionStore';
import { safeConnectionName, safeServerText } from '../../../../types/safeConnectionDisplay';

/** The account name, with the connection's alias when that says something else; `fallback` without a connection. */
export function storageAccountLabel(connection: Connection | undefined, fallback: string): string {
  if (!connection) return fallback;
  const account = resolveStorageEndpoints(connection).accountName ?? safeServerText(connection.server);
  const alias = connection.alias?.trim() && safeConnectionName(connection);
  return alias && alias !== account ? `${account} (${alias})` : account;
}

export function StorageAccountName({ connectionId }: { connectionId: string }) {
  const connection = useConnectionStore((state) => state.connections.find((candidate) => candidate.id === connectionId));
  return <span className="font-medium text-foreground [overflow-wrap:anywhere]" data-testid="storage-dialog-account">{storageAccountLabel(connection, connectionId)}</span>;
}
